import apple from "../assets/images/organic-coconut/Organic-yoghurt.png"

let yoghurts = [
  {name: 'Organic Coconut', image: apple, subtitle: 'Yoghurt alternative'},
]

export default yoghurts
